import React, { useState } from 'react'
import { ItensPerUserLogged } from '../../../../../services/login/permissaoUsuarioLoado'
import { removerAcentos } from '../../../../../utils'
import { Inline } from '../../../../../Components/CustomUi/inline'
import Input from '../../../../../Components/CustomUi/input'
import ButtonCustom from '../../../../../Components/ButtonCustom'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faEdit, faEye, faPlus } from '@fortawesome/free-solid-svg-icons'
import { HeaderTable } from '../../../../../Components/CustomUi/table/headerTable'
import { BodyTable } from '../../../../../Components/CustomUi/table/bodyTable'
import { Render } from '../../../../../Components/CustomUi/render'
import { RowTable } from '../../../../../Components/CustomUi/table/rowTable'
import { RowItem } from '../../../../../Components/CustomUi/table/rowItem'
import { DeleteButton } from '../../../../../Components/CustomUi/deleteButton'
import { Empty, Tag } from 'antd'
import Carregando from '../../../../../Components/CustomUi/loading'
import { Select } from '../../../../../Components/CustomUi/Select'

interface Props {
  loading: boolean
  setPagination: React.Dispatch<React.SetStateAction<number>>
  page: number
  setPage: React.Dispatch<React.SetStateAction<number>>
  total: number
  listar_cadastro_propriedade: any[]
  data_propriedades: any[]
  setOpen: React.Dispatch<React.SetStateAction<boolean>>
  permissao: ItensPerUserLogged
  editarCadastro: Function
  deletar: Function
  confirmar_exclusao: boolean
  setConfirmar_exclusao: React.Dispatch<React.SetStateAction<boolean>>
  id_item_atual: number
  setId_item_atual: React.Dispatch<React.SetStateAction<number>>
  nome_item_atual: string
  setNome_item_atual: React.Dispatch<React.SetStateAction<string>>
  fake_loading: boolean
  setFake_loading: React.Dispatch<React.SetStateAction<boolean>>
  buscar_tabela: string
  setBuscar_tabela: React.Dispatch<React.SetStateAction<string>>
  propriedade_selecionada: string
  setPropriedade_selecionada: React.Dispatch<React.SetStateAction<string>>
}

export const TabelaConfig: React.FC<Props> = ({
  loading,
  page,
  setPage,
  setPagination,
  total,
  listar_cadastro_propriedade,
  data_propriedades,
  setOpen,
  permissao,
  editarCadastro,
  deletar,
  confirmar_exclusao,
  setConfirmar_exclusao,
  id_item_atual,
  setId_item_atual,
  nome_item_atual,
  setNome_item_atual,
  fake_loading,
  setFake_loading,
  buscar_tabela,
  setBuscar_tabela,
  propriedade_selecionada,
  setPropriedade_selecionada,
}) => {
  const [openSelect, setOpenSelect] = useState<boolean>(false)

  function buscarPropriedade(buscar_nome: string) {
    const palavraSemAcentos = removerAcentos(buscar_nome)
    return function (item) {
      const nomeSemAcentos = removerAcentos(String(item?.nome))
      return nomeSemAcentos.toLowerCase().includes(palavraSemAcentos.toLowerCase()) || !buscar_nome
    }
  }

  return (
    <>
      <Inline alignItems='center'>
        {/* <Select
          value={propriedade_selecionada}
          onChange={setPropriedade_selecionada}
       
          open={openSelect}
          trigger={setOpenSelect}
          items={data_propriedades}
          descricaoItem={'nome'}
          idItem={'cod'}
        /> */}
        <Input placeholder='Buscar propriedade' value={buscar_tabela} onChange={setBuscar_tabela} />
        <ButtonCustom icon={<FontAwesomeIcon icon={faPlus} />} onClick={() => setOpen(true)}>
          Novo
        </ButtonCustom>
      </Inline>
      <HeaderTable
        itens={[
          { valor: 'Propriedade', width: 'calc(100% - 623px)' },
          { valor: 'Calcários', width: '500px' },
          { valor: 'Ações', width: '118px' },
        ]}
      />

      <BodyTable
        paginate={total}
        onChangeItensPage={setPagination}
        onChangePage={setPage}
        current_page={page}
        setCurrent_page={setPage}
        style={{
          height: 'calc(100vh - 365px)',
          position: 'relative',
          overflowX: 'hidden',
          overflowY: 'scroll',
          marginTop: -10,
        }}
      >
        <Render condition={!loading}>
          {(listar_cadastro_propriedade ?? [])
            .filter(buscarPropriedade(buscar_tabela))
            .map((item) => {
              return (
                <RowTable
                  key={item?.cod}
                  onDoubleClick={() => editarCadastro(item?.cod)}
                  style={{ height: 'auto' }}
                >
                  <RowItem fontSize={13} width={'calc(100% - 618px)'}>
                    {item?.nome}
                  </RowItem>
                  <RowItem
                    fontSize={13}
                    width={'500px'}
                    style={{
                      display: 'flex',
                      flexWrap: 'wrap',
                      justifyContent: 'flex-start',
                      alignContent: 'center',
                    }}
                  >
                    {item?.calcarios
                      ?.filter((word) => word !== '')
                      .map((item) => {
                        return (
                          <Tag  color={item?.padrao === true && 'green'} key={item?.cod} style={{ margin: 5, fontSize: '11px' }}>
                            {item?.calcario_nome}
                          </Tag>
                        )
                      })}
                  </RowItem>
                 
                  <RowItem width={'118px'} gap={10}>
                    <ButtonCustom
                      icon={<FontAwesomeIcon icon={permissao?.acesso === 1 ? faEye : faEdit} />}
                      onClick={() => {
                        editarCadastro(item?.cod)
                      }}
                      disabled={permissao?.alteracao === 0 && permissao?.acesso === 1}
                    >
                      {permissao?.acesso === 1 ? 'Ver' : 'Editar'}
                    </ButtonCustom>
                  </RowItem>
                </RowTable>
              )
            })}
        </Render>

        <Render condition={listar_cadastro_propriedade.length === 0 && !loading}>
          {buscar_tabela === '' ? (
            <Empty
              image={Empty.PRESENTED_IMAGE_SIMPLE}
              description={<> Nenhum registro disponível!</>}
            />
          ) : (
            <Empty
              image={Empty.PRESENTED_IMAGE_SIMPLE}
              description={
                <>
                  {' '}
                  <b>'{buscar_tabela}'</b> não encontrado!
                </>
              }
            />
          )}
        </Render>

        <Render condition={loading}>
          <Carregando
            animation
            legenda='Carregando fornecedores...'
            justifyContent='center'
            height={400}
            size='default'
          />
        </Render>
      </BodyTable>
    </>
  )
}